import React, { FC, useEffect } from 'react'
import rules from '../data/rules'

const RulesPage: FC = () => {

    //scroll to top when component rendered
    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);

    return (
        <section className='rulespage'>
            <div className="rulespage__title">
                <h3>Правила для відвідувачів</h3>
            </div>
            <ul className='rulespage__list'>
                {
                    rules.map(rule => (
                        <li className='rulespage__list-elem'>
                            <p className='title'>Правило №{rule.id + 1}</p>
                            <p className='rule'>{rule.text}</p>
                        </li>
                    ))
                }
            </ul>
        </section>
    )
}

export default RulesPage